import { ulid } from "@/schemas/commonFields";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import { z } from "@/zod";

export const readProjectManager = z.object({
  id: ulid,
  ref_number: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  full_name: z.string(),
  system_role_id: ulid,
  system_role_code: z.nativeEnum(SYSTEM_ROLE_CODE),
  system_role_name: z.string(),
  project_id: ulid.nullable(),
});

export const displayProjectManager = readProjectManager
  .omit({
    system_role_code: true,
    first_name: true,
    last_name: true,
    ref_number: true,
  })
  .readonly();
